<p-card header="Регистрация {{ data.dateRegister }}">
  <table class="table table-sm table-striped">
    <tbody>
      <tr>
        <td style="width: 15%;" class="font-bold">Статус</td>
        <td style="width: 35%;">
          <span class="badge badge-primary" [ngClass]="{
        'badge-light': data.rankId == 0 || data.rankId == 9,
        'badge-success': data.rankId == 6 || data.rankId == 1,
        'badge-danger': data.rankId == 4 || data.rankId == 5 || data.rankId == 12 || data.rankId == 13,
        'badge-warning': data.rankId == 10,
        'badge-dark': data.rankId == 11
      }">{{ data.rankName }}</span>
          <span *ngIf="data.isAutoreg" class="badge badge-info">Online</span>
        </td>
        <td style="width: 15%;">
          <span *ngIf="data.companyName" class="font-bold">Компания</span>
        </td>
        <td style="width: 35%;">
          <span *ngIf="data.companyName" class="badge badge-info">
            {{ data.companyName }}
          </span>
        </td>
      </tr>
      <tr>
        <td style="width: 15%;" class="font-bold">Прибыл</td>
        <td style="width: 35%;">
          <span *ngIf="!data.isArrive" class="badge badge-secondary">НЕТ</span>
          <span *ngIf="data.isArrive" class="badge badge-success">ДА</span>
        </td>
        <td style="width: 15%;" class="font-bold">Дата</td>
        <td style="width: 35%;">
          <span *ngIf="data.isArrive">{{ data.dateArrive }}</span>
        </td>
      </tr>
      <tr>
        <td style="width: 15%;" class="font-bold">Бейдж</td>
        <td style="width: 35%;">
          <span *ngIf="!data.isNeedBadge" class="badge badge-secondary">НЕТ</span>
          <span *ngIf="data.isNeedBadge" class="badge badge-success">ДА</span>
        </td>
        <td style="width: 15%;" class="font-bold">Напечатан</td>
        <td style="width: 35%;">
          <span *ngIf="!data.isBadgePrinted" class="badge badge-secondary">НЕТ</span>
          <span *ngIf="data.isBadgePrinted" class="badge badge-success">ДА</span>
        </td>
      </tr>
    </tbody>
  </table>
  <!-- <dl class="row">
    <dt class="col-sm-3">Статус</dt>
    <dd class="col-sm-9">
      <span class="badge badge-primary" [ngClass]="{
        'badge-light': data.rankId == 0 || data.rankId == 9,
        'badge-success': data.rankId == 6 || data.rankId == 1,
        'badge-danger': data.rankId == 4 || data.rankId == 5 || data.rankId == 12 || data.rankId == 13,
        'badge-warning': data.rankId == 10,
        'badge-dark': data.rankId == 11
      }">{{ data.rankName }}</span>
      <span *ngIf="data.isAutoreg" class="badge badge-info">Online</span>
    </dd>
  </dl> -->
  <!-- <dl class="row">
    <dt class="col-sm-3">Прибыл</dt>
    <dd class="col-sm-3">
      <span *ngIf="!data.isArrive" class="badge badge-secondary">НЕТ</span>
      <span *ngIf="data.isArrive" class="badge badge-success">ДА</span>
    </dd>
    <dt class="col-sm-2">Дата</dt>
    <dd class="col-sm-4" *ngIf="data.isArrive">{{ data.dateArrive }}</dd>
  </dl> -->
  <!-- <dl class="row">
    <dt class="col-sm-3">Бейдж</dt>
    <dd class="col-sm-3">
      <span *ngIf="!data.isNeedBadge" class="badge badge-secondary">НЕТ</span>
      <span *ngIf="data.isNeedBadge" class="badge badge-success">ДА</span>
    </dd>
    <dt class="col-sm-3">Напечатан</dt>
    <dd class="col-sm-3">
      <span *ngIf="!data.isBadgePrinted" class="badge badge-secondary">НЕТ</span>
      <span *ngIf="data.isBadgePrinted" class="badge badge-success">ДА</span>
    </dd>
  </dl> -->
  <!-- <dl class="row" *ngIf="data.companyName">
    <dt class="col-sm-3">Компания</dt>
    <dd class="col-sm-9">
      <span class="badge badge-info">
        {{ data.companyName }}
      </span>
    </dd>
  </dl> -->

  <ng-template pTemplate="footer" >
    <p-button *ngIf="!isReadOnly" label="Редактировать" styleClass="p-button-warning mr-2 mt-3" (click)="onEdit()"></p-button>
    <p-button label="Печать Приглашения" styleClass="p-button-success mr-2 mt-3" (click)="onPrintInvitation()"></p-button>
    <p-button label="Отправить Приглашение" styleClass="p-button-success mr-2 mt-3"
      (click)="onSendInvitation()"></p-button>


  </ng-template>
</p-card>
